import ContactUs from "./components/ContactUs";
import { useTranslation } from "react-i18next";

// Quality page component that includes all sections
export function QualityPage() {
  return (
    <main>
      <Main />
      <Service />
      <Policies />
      <OurValues />
      <ContactUs />
    </main>
  );
}

function Main() {
  const { t } = useTranslation();
  
  return (
    <div
      className="py-16 relative"
      style={{
        backgroundImage: "url(/assets/img/quality/main.png)",
        backgroundSize: "cover",
        backgroundPosition: "100% center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container px-8 md:px-[100px] py-[130px] relative z-10">
        <h1 className="text-left md:leading-[64px] text-[40px] md:text-5xl font-light text-white mb-8">
          {t('QualityPage.main.title')}
        </h1>
      </div>
    </div>
  );
}

function Service() {
  const { t } = useTranslation();
  
  const descriptions = [
    { desc: t('QualityPage.service.benefits.safe') },
    { desc: t('QualityPage.service.benefits.organized') },
    { desc: t('QualityPage.service.benefits.focused') },
  ];
  
  return (
    <div id="ISO:9001" className="bg-[#F2F6FB] relative md:pb-32 pb-16 w-full">
      <img
        className="absolute top-0 left-0 z-0"
        src="/assets/img/diagonal-left.png"
        alt="Diagonal"
        loading="lazy"
        decoding="async"
      ></img>
      <div className="px-8 md:px-[100px] md:pt-[130px] pt-16 relative z-10">
        <div className={`space-y-28 transition-all duration-1000 delay-600`}>
          <div className="md:flex space-y-12 md:space-y-0 gap-x-16">
            <div className="w-full flex flex-col space-y-8">
              <img
                src="/assets/img/quality/Sistema-calidad-1.jpg"
                alt="Our Process"
                className="rounded-lg"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </div>
            <div className="w-full text-left ">
              <div className="font-normal space-y-8">
                <p className={`text-[50px] text-[#222222]`}>
                  {t('QualityPage.service.title')}
                </p>
                <p className={`text-[#2B2B2E] text-xl leading-[32px]`}>
                  {t('QualityPage.service.description')}
                  <span className="font-semibold">
                    {t('QualityPage.service.descriptionBold')}
                  </span>{" "}
                  {t('QualityPage.service.description2')}
                </p>
                <p className="text-lg text-[#0B4797] font-normal leading-[24px] space-y-6">
                  {t('QualityPage.service.subtitle')}
                </p>
              </div>
              <div className="my-8">
                {descriptions.map((description) => (
                  <div className="my-6 flex items-center space-x-2" key={description.desc}>
                    <img
                      src={`/assets/svg/check.svg`}
                      alt={"check"}
                      loading="lazy"
                      decoding="async"
                    />
                    <p className="hover:text-[#0B4494] transition-all duration-300 text-base font-medium leading-[24px]">
                      {description.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Policies() {
  const { t } = useTranslation();
  
  return (
    <div id="policies" className="py-16 relative">
      <div className="container px-8 md:px-24 py-6 space-y-16 relative z-10">
        <p className="text-left  md:text-[50px] text-2xl font-medium text-[#001973]">
          {t('QualityPage.policies.title')}
        </p>
        <div className="md:grid grid-cols-2 border border-[#2C4088] rounded-[40px]">
          <div className="p-8 space-y-8 border-b md:border-r border-[#2C4088]">
            <p className="text-left md:text-[28px] text-2xl font-semibold text-[#001973]">
              {t('QualityPage.policies.quality.title')}
            </p>
            <p className="text-left md:leading-[28px] leading-[30px] md:text-base text-2xl font-normal text-[#2B2B2E]">
              {t('QualityPage.policies.quality.part1')}{" "}
              <span className="font-semibold">
                {t('QualityPage.policies.quality.bold1')}
              </span>{" "}
              {t('QualityPage.policies.quality.part2')}{" "}
              <span className="font-semibold">
                {t('QualityPage.policies.quality.bold2')}
              </span>
              {t('QualityPage.policies.quality.part3')}
            </p>
          </div>
          <div className="space-y-8 p-8 border-b border-[#2C4088]">
            <p className="text-left md:text-[28px] text-2xl font-semibold text-[#001973]">
              {t('QualityPage.policies.vision.title')}
            </p>
            <p className="text-left md:leading-[28px] leading-[30px] md:text-base text-2xl font-normal text-[#2B2B2E]">
              {t('QualityPage.policies.vision.part1')}{" "}
              <span className="font-semibold">
                {t('QualityPage.policies.vision.bold')}
              </span>
              {t('QualityPage.policies.vision.part2')}
            </p>
          </div>
          <div className="space-y-8 p-8 md:border-r border-[#2C4088]">
            <p className="text-left md:text-[28px] text-2xl font-semibold text-[#001973]">
              {t('QualityPage.policies.mission.title')}
            </p>
            <p className="text-left md:leading-[28px] leading-[30px] md:text-base text-2xl font-normal text-[#2B2B2E]">
              {t('QualityPage.policies.mission.part1')}{" "}
              <span className="font-semibold">
                {t('QualityPage.policies.mission.bold')}
              </span>{" "}
              {t('QualityPage.policies.mission.part2')}
            </p>
          </div>
          <div
            className="min-h-[300px] bg-cover bg-center bg-no-repeat rounded-br-[40px]"
            style={{
              backgroundImage: "url(/assets/img/quality/Sistema-calidad-2.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        </div>
      </div>
    </div>
  );
}

function OurValues() {
  const { t } = useTranslation();
  
  return (
    <div className="py-16">
      <p className="text-center md:text-[50px] text-2xl font-medium text-[#001973]">
        {t('QualityPage.values.title')}
      </p>
      <div className="md:py-16 py-8 md:space-y-16 space-y-4">
        <div className="justify-between md:flex 2xl:px-32 px-4 space-y-4 md:space-y-0">
          <div className="md:w-[400px] h-[179px] border border-[#001973] rounded-[40px]">
            <p className="flex justify-center items-center h-full md:text-[28px] text-[20px] font-normal text-[#222222] m-auto">
              {t('QualityPage.values.seriousness')}
            </p>
          </div>
          <div className="md:w-[400px] h-[179px] border border-[#001973] bg-[#0019734D]/20 rounded-[40px] p-6">
            <p className="flex justify-center items-center h-full md:text-[28px] text-[20px] font-normal text-[#001973]">
              {t('QualityPage.values.honesty')}
            </p>
          </div>
          <div className="md:w-[400px] h-[179px] border border-[#001973] rounded-[40px] p-6">
            <p className="flex justify-center items-center h-full md:text-[28px] text-[20px] font-normal text-[#222222]">
              {t('QualityPage.values.reliability')}
            </p>
          </div>
        </div>
        <div className="justify-center gap-x-32 md:flex 2xl:px-32 px-4  space-y-4 md:space-y-0">
          <div className="md:w-[400px] h-[179px] border border-[#001973] bg-[#0019734D]/20 rounded-[40px] p-6">
            <p className="flex justify-center items-center h-full md:text-[28px] text-[20px] font-normal text-center text-[#001973]">
              {t('QualityPage.values.commitment')}
            </p>
          </div>
          <div className="md:w-[400px] h-[179px] border border-[#001973] rounded-[40px]">
            <p className="flex justify-center items-center h-full md:text-[28px] text-[20px] font-normal text-[#222222] m-auto">
              {t('QualityPage.values.responsibility')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
